import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadingComponent } from './shared/spinner/loading/loading.component';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
    <app-loading></app-loading>
  `,
  styles: [`
    .container {
      display: flex;
      flex-direction: column;
      height: 100vh;
    }
  `],
  standalone: true,
  imports: [RouterModule, LoadingComponent]
})
export class AppComponent { }
